import React, { useState, useEffect } from "react"
import "./styles.scss";
import { convertPrice, convertAmount } from './../../../services/convertPrice'
import calendar from './../../../images/calendar-ico.svg'
import info from './../../../images/i-ico-blue.svg'
import ModalMessage from '../../modal-message/ModalMessage';
import isPaselValid from 'pesel-check';

export default props => {
  let [ value, setValue ] = useState("");
  let [ focus, setFocus ] = useState( false );
  let [ focusCount, setFocusCount ] = useState( 0 );
  let [ error, setError ] = useState( false );
  let [ errorText, setErrorText ] = useState();
  let [ load, setLoad ] = useState( false );
  let [ activeModal, setActiveModal ] = useState(false);
  

  //focus count
  useEffect(() => {
    setFocusCount(++focusCount);
  }, [focus])
  // first focus 
  useEffect(() => {
    if ( focusCount === 2 && props.firstLoadValue ) {
        setValue(props.firstLoadValue)
    }
  }, [focusCount])

  //checkValue 
  let checkValue = (val) => {
    if ( props.allowChars  ) {
        if (val.length > 0) {
            let regExp = new RegExp(props.allowChars);
            if(regExp.test(val)) {
                setValue(val);
            }
        } else {
            setValue('');
        }
    } else {
        setValue(val);
    }
  }
  //change value
  useEffect(() => {
    if ( load && props.setFunction) {
        if ( props.regExp ) {
            let regExp = new RegExp(props.regExp);
            if(regExp.test(value)) {
                props.setFunction( value );
            }
        } else {
            props.setFunction( value );
        }
    }
  }, [value])

  // force validate again when clicked submit button
  useEffect(() => {
    if ( load ) {
        validate();
    }
  }, [props.forceValidate])

  useEffect(() => {
    if ( load ) {
        validate();
    }
  }, [props.forceValidateItems])

  // set value
  useEffect(() => {
      if ( props.val !== value) {
        setValue(props.val)
      }
  }, [props.val])

  // set if data is loaded
  useEffect(() => {
    if ( !load ) {
        setLoad(true);
    }
  }, [load])

  useEffect(() => {
    if ( props.disabledForce ) {
        setValue('')
        props.setFunction('');
    } 
  }, [props.disabledForce])

  const validate = (valItem) => {
        let val = ( valItem ? valItem : value )
      // check if empty
      if ( props.required &&  val.length === 0) {
            setErrorText('Required')
            setError(true);
            return false;

        } else {
            setError(false);
        }

        //check length 
        if ( props.required && val.length < props.minChar ) {
            setError(true);       
            setErrorText('Mało znaków');
            return false;
        } else {
            setError(false);
        }


        //check format
        if ( props.required && props.regExp ) {
            
            let regExp = new RegExp(props.regExp);

            if(regExp.test(val)) {
                setError(false);
            } else {
                setError(true);       
                setErrorText('Zły format')
            }
        }

        //check pesel
        if( !isPaselValid(val) ) {
            setError(true);       
            setErrorText('Niepoprawny PESEL')
        } else {
            setError(false);
        }

        return true;
        
  }

  return (
    <div className={ "form-item " + props.size + ' ' + ( error ? 'error-item ' + ( props.errorClass ? props.errorClass : '' ) : '' )} >
        <label className={  ( props.disabledForce ? 'disabled-force':'' ) + ' ' +
                            ( focus || props.activeInput ? 'focus':'' ) + ' ' +
                            ( value && value.length > 0 ? 'filled' : '' ) + ' ' +  
                            ( error && !props.disabledForce ? 'error' : '' ) + ' ' + 
                            ( props.activeInput ? 'disabled':'') }>
            <input
            name={props.name}
            onChange={ e => {
                checkValue(e.target.value);
            }}
            onFocus={  () => setFocus( true ) }
            onClick={ () => setFocus( true )}
            onBlur={ (e) => { 
                
                setFocus(false); 
                validate();

                if ( props.setValidateSelectField ) {
                    props.setForceValidateFromName()
                }
                if ( props.formatPrice && e.target.value.length >= 1 ) {
                    let val =  e.target.value
                        val = val.replace(/\s/g, '');
                    let valWithoutSpaces = val;
                        val = val.replace(',', '.')
                        val = parseFloat(val);

                    let input = parseFloat(val).toFixed(2);
                    let regExp = new RegExp(props.regExp);
                    if(regExp.test(valWithoutSpaces)) {
                        setValue(convertPrice(input));
                        validate(valWithoutSpaces);
                    }
                }
                if ( props.formatAmount && e.target.value.length >= 1 ) {
                    let val =  e.target.value
                        val = val.replace(/\s/g, '');
                    let valWithoutSpaces = val;
                        val = val.replace(',', '.')
                        val = parseFloat(val);

                    let input = parseFloat(val).toFixed(2);
                    let regExp = new RegExp(props.regExp);
                    if(regExp.test(valWithoutSpaces)) {
                        setValue(convertAmount(input));
                        validate(valWithoutSpaces);
                    }
                }

            }}
            required={ props.required }
            type={ props.type }
            className={ props.class && props.class }
            placeholder=""
            value={ value }
            id={props.id ? props.id : ''}
            disabled={ props.disabled || props.disabledForce ? true : null }
            />
            <div className="placeholder">
                <span className="underline"></span>
                <span className="text">{ props.placehold }</span>
            </div>
            { error && !props.disabledForce && 
                <div className="error-message">
                    { errorText }
                </div>
            }
            { props.calendar &&
                <img src={ calendar } alt="Kalendarz" />
            }
           
            
        </label>
        { props.tip && 
            <img src={ info } className="tip" alt="informacja" onClick={ () => setActiveModal( true )} />
        }
        { activeModal &&
            <ModalMessage closeModal={ () => setActiveModal(false) } 
                        button={ props.button } 
                        buttonClass="blue" 
                        buttonTitle={ props.buttonTitle }
                        buttonArrow={ true } 
                        tipHeader={ props.tipHeader }
                        tipText={ props.tipText } />
        }
    </div>
  )
}
